import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import { translate, prefix } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Navigation.scss';


const Navigation = ({ navigation, setup, menuPopupHeight, openMenuHandler, resetFilterHandler }) => {
	const [expandedMenuItem, expandMenuItem] = useState(null);

	const expandMenuHandler = (e) => {
		const index = Array.from(e.currentTarget.closest('ul').children).indexOf(e.currentTarget.closest('li'));

		if (expandedMenuItem !== index && window.innerWidth < 1100) {
			e.preventDefault();
			expandMenuItem(index);
		} else {
			expandMenuItem(null);
		}
	};

	return (
		<nav className={s.navigation}>
			<a className={[s.navigation_mobileMenu, (navigation.open ? s.navigation_mobileMenu__open : null)].join(' ')} href="#open-mobile-menu" aria-label="Open mobile menu" onClick={openMenuHandler}>
				<span /><span /><span />
			</a>
			<ul className={s.level1} style={{ height: `${menuPopupHeight}px` }}>
				{
					navigation.header.map((level1, i) => {
						const level1URI = translate(setup, level1, 'uri');
						const level2SubCategoryLinks = [];
						const level2Links = [];
						let level2HasSubCategories = false;

						if (level1.subPages) {
							// Get column with most links
							const dropdownCSS = {};
							const maxTotalLinks = level1.subPages.reduce((acc, val) => (val.subPages ? [...acc, (val.subPages.length + 1)] : acc), []).sort((a, b) => b - a);
							const listHeight = maxTotalLinks.length > 0 && maxTotalLinks[0] > 7 ? maxTotalLinks[0] / 2 : maxTotalLinks[0];
							// if (listHeight < maxTotalLinks.slice(-1)) listHeight = maxTotalLinks.slice(-1);
							if (listHeight) dropdownCSS.height = (Math.ceil(listHeight) * 33) + 43;

							level1.subPages.forEach((level2) => {
								const level2URI = translate(setup, level2, 'uri');

								if (level2.subPages) {
									level2SubCategoryLinks.push(
										<div key={urlify(level2URI)} className={[s.level2_block, ...(level2.subPages.length > 9 ? [s.level2_block__doubleColumn] : [])].join(' ')} style={dropdownCSS}>
											<div className={s.level2_block_item}>
												<Link onClick={resetFilterHandler} className={s.level2_block_item_link} to={prefix(setup, level2URI)}><span>{translate(setup, level2, 'title')}</span></Link>
											</div>
											{
												level2.subPages.map((level3) => {
													const level3URI = translate(setup, level3, 'uri');
													level2HasSubCategories = true;
													return (
														<div className={s.level3_block_item} key={urlify(level3URI)}>
															<Link onClick={resetFilterHandler} className={s.level3_block_item_link} to={prefix(setup, level3URI)}><span>{translate(setup, level3, 'title')}</span></Link>
														</div>
													);
												})
											}
										</div>,
									);
								} else {
									level2Links.push(
										<div className={s.level2_block_item} key={urlify(level2URI)}>
											<Link onClick={resetFilterHandler} className={s.level2_block_item_link} to={prefix(setup, level2URI)}><span>{translate(setup, level2, 'title')}</span></Link>
										</div>,
									);
								}
							});
						}

						const level1Click = {};
						let expandable = null;
						if (level1.subPages) {
							level1Click.onClick = expandMenuHandler;
							expandable = <svg className={s.level1_column_link_expandIndicator} xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><polyline points="1167 1513 1173 1519 1179 1513" transform="translate(-1166 -1512)" /></svg>;
						} else {
							level1Click.onClick = resetFilterHandler;
						}

						return (
							<li className={[s.level1_column, (expandedMenuItem === i ? s.level1_column__expanded : null)].join(' ')} key={urlify(level1URI)}>
								<Link className={s.level1_column_link} to={prefix(setup, level1URI)} {...level1Click}>
									<span>{translate(setup, level1, 'title')}</span>
									{expandable}
								</Link>
								{
									level1.subPages ? (
										<div className={s.level1_columnInner}>
											<div className={[s.level2, (level2Links.length > 0 ? s.level2__minimal : null)].join(' ')}>
												{ level2SubCategoryLinks }
												{ level2Links.length > 0 ? <div className={[s.level2_block, (level2HasSubCategories ? null : s.level2_block__noSubCategories)].join(' ')}>{ level2Links }</div> : null }
											</div>
										</div>
									)	: null
								}
							</li>
						);
					})
				}
			</ul>
		</nav>
	);
};

export default hot(module)(Navigation);
